<template>
  <div class="outer">
    <div class="header">举报理由 {{form.reportClass}}</div>
    <div class="content">
      <van-field
        v-model="message"
        rows="2"
        :autosize="{minHeight: 148}"
        type="textarea"
        maxlength="200"
        placeholder="请描述你的举报内容（选填）"
        show-word-limit
      />
      <div class="onload">
        <van-uploader
          :after-read="afterRead"
          v-model="fileList"
          multiple
          :max-count="4"
          @delete="deleteHandler"
        >
          <div class="picture">
            <img class="upload" src="../assets/image/add.png" />
            <div class="num">{{count}}/4</div>
          </div>
        </van-uploader>
        <div class="explain">您的的举报将在72小时内受理，若举报成功会第一时间告知处理结果，请尽量提交完整的举报描述及材料，无需重复举报，谢谢您的配合。</div>
        <van-button type="danger" class="btn" @click="submitHandler">提交</van-button>
      </div>
    </div>
  </div>
</template>
<script>
import {uploadImage,tipoff} from '@/api'
import { setTimeout } from 'timers';
export default {
  data() {
    return {
      message: "",
      fileList: [],
      count: 0,
      form: {},
      fileArr: []
    };
  },
  mounted() {
    this.form = this.$store.state.form
  },
  methods: {
    afterRead(file) {
      if (Array.isArray(file)) {
        this.fileArr.push(...file);
        this.count += file.length;
      } else {
        this.fileArr.push(file);
        this.count++;
      }
    },
    submitHandler() {
      this.form.reportContent = this.message
      const formData = new FormData();
      if(this.fileArr.length===0){
        this.$toast("请至少选择一张图片");
        return
      }
      this.fileArr.forEach(item => {
        formData.append("file", item.file);
      });
      uploadImage(formData).then(res => {
        const { code,data } = res
        if (code === "200") {
          this.form.image = data
          tipoff(this.form).then(res => {
            if (res.code == "200") {
              this.$toast("提交成功");
              // 调用原生方法
              setTimeout(()=>{
                if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
                  window.webkit.messageHandlers.popViewController.postMessage(null);
                } else if (navigator.userAgent.match(/android/i)) {
                  window.android.appFinish();
                }
              }, 500)
            }else{
              this.$toast(res.msg);
            }
          })
        }
      })
      // axios.post("https://tdapp.qudao51.cn/exp-shop/report/upload/image", formData).then(res => {
      //   const { data } = res
      //   if (data.code === "200") {
      //     this.form.image = data.data;
      //     axios.post("https://tdapp.qudao51.cn/exp-shop/report/reportPost/v1",this.form).then(res => {
      //       if (res.data.code == "200") {
      //         this.$toast("提交成功");
      //         // this.$router.back()
      //         // 调用原生方法
      //         setTimeout(()=>{
      //           if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
      //             window.webkit.messageHandlers.popViewController.postMessage(null);
      //           } else if (navigator.userAgent.match(/android/i)) {
      //             window.android.appFinish();
      //           }
      //         }, 500)
      //       }else{
      //         this.$toast(res.data.msg);
      //       }
      //     }).catch(error => {
      //       this.$toast(error);
      //     });
      //   }
      // });
    },
    deleteHandler(file) {
      this.fileArr = this.fileArr.filter(item => {
        return item.file.lastModified != file.file.lastModified;
      });
      this.count--;
    }
  }
};
</script>
<style lang="scss" scoped>
.outer {
  .header {
    height: 106px;
    font-size: 32px;
    font-weight: 500;
    color: rgba(51, 51, 51, 1);
    line-height: 106px;
    padding-left: 30px;
    border-top: 1px solid rgba(234, 234, 234, 1);
    border-bottom: 1px solid rgba(234, 234, 234, 1);
  }
  .content {
    .onload {
      margin-top: 10px;
      padding: 0 33px;
      .picture {
        position: relative;
        .upload {
          width: 160px;
          height: 160px;
        }
        .num {
          position: absolute;
          min-width: 40px;
          height: 30px;
          background: #ebebeb;
          bottom: 16px;
          left: 50%;
          transform: translateX(-50%);
          color: #9d9d9d;
        }
      }

      .explain {
        margin-top: 37px;
        font-size: 24px;
        font-weight: 400;
        color: rgba(182, 182, 182, 1);
        line-height: 36px;
      }
      .btn {
        margin-top: 50px;
        width: 100%;
        height: 88px;
        background: rgba(243, 71, 74, 1);
        border-radius: 4px;
      }
    }
  }
}
</style>